import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_API_KEYS_LIST',
  'DELETE_API_KEY',
  'DELETE_API_KEY_SUCCESS',
  'CREATE_API_KEY',
]);
